module.exports = __webpack_public_path__ + "static/claude_1-c8c69e76e71875c6aabe83b6718a6157.png";